export default __webpack_public_path__ + "static/media/banner-b.165cbdf6.jpg";